(function () {
  document.querySelectorAll('[data-dd-logo]').forEach(initLogoShrink);

  function initLogoShrink(logo) {
    if (logo.getAttribute('data-shrink') !== 'true') return;

    var inner = logo.querySelector('.dd-hero__logo-inner');
    if (!inner) return;

    var minScale = parseFloat(logo.getAttribute('data-shrink-scale')) || 0.6;
    var distance = parseFloat(logo.getAttribute('data-shrink-distance')) || 60;
    if (distance <= 0) distance = 1;

    var ticking = false;

    function update() {
      var scrollY = window.scrollY || window.pageYOffset || 0;
      var progress = Math.min(scrollY / distance, 1);
      var scale = 1 - progress * (1 - minScale);
      inner.style.transform = 'scale(' + scale + ')';
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();